import { render, staticRenderFns } from "./BoardListComponent.vue?vue&type=template&id=65535830&scoped=true&"
import script from "./BoardListComponent.vue?vue&type=script&lang=js&"
export * from "./BoardListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65535830",
  null
  
)

export default component.exports